module.exports = __webpack_public_path__ + "img/logo_adiber.482ff80e.png";